import React from 'react';

import Description from '@components/lpc/Pot/MainModule/Informations/Description/Description';

type InformationsProps = {
    personRole: string;
    potRef: string;
    potLink: string;
    description: string;
    category: string;
    solidaryCategory?: string;
    eventDate: string;
    isOffered: boolean;
};
const Informations = ({
    personRole,
    potRef,
    description,
    category,
    solidaryCategory,
    eventDate,
    isOffered,
}: InformationsProps) => {
    return (
        <>
            <div className="Description">
                <Description
                    personRole={personRole}
                    potRef={potRef}
                    description={description}
                    category={category}
                    solidaryCategory={solidaryCategory}
                    eventDate={eventDate}
                    isOffered={isOffered}
                />
            </div>
        </>
    );
};

export default Informations;
